class ExpandingContent {
  constructor(scopeElement, animationSpeed = 300) {
    this.scope = scopeElement;
    this.main = this.scope.querySelector('.expanding-content-main');
    this.toggleButton = this.scope.querySelector('.expanding-content-toggle');
    this.animationSpeed = animationSpeed;

    if (this.main && this.toggleButton) {
      this.setupAccessibility();

      this.toggleButton.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        this.toggle();
      });

      this.toggleButton.addEventListener('keydown', (e) => this.handleKeydown(e));
    }
  }

  setupAccessibility() {
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.setAttribute('aria-controls', this.main.id || this.generateId(this.main));
    this.main.setAttribute('aria-hidden', 'true');

    if (!this.toggleButton.hasAttribute('role')) {
      this.toggleButton.setAttribute('role', 'button');
    }

    if (!this.main.id) {
      this.main.id = this.generateId(this.main);
    }
  }

  generateId(element) {
    return 'expanding-' + Math.random().toString(36).substr(2, 9);
  }

  handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.toggle();
    }
  }

  toggle() {
    const isOpen = this.scope.classList.contains('expanding-open');
    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.scope.classList.add('expanding-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.main.setAttribute('aria-hidden', 'false');
    this.slideDown(this.main);
  }

  close() {
    this.scope.classList.remove('expanding-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.main.setAttribute('aria-hidden', 'true');
    this.slideUp(this.main);

    // Read CSS variable --pad-gbl and convert to pixels
    const rootStyles = getComputedStyle(document.documentElement);
    const padGbl = rootStyles.getPropertyValue('--pad-gbl').trim();
    const padGblPx = this.convertToPixels(padGbl);

    // Scroll to top of scope adjusted by padding
    const scopeTop = this.scope.getBoundingClientRect().top + window.scrollY;
    const viewportHeight = window.innerHeight;
    const scrollTarget = scopeTop - (viewportHeight - this.toggleButton.offsetHeight - padGblPx);

    window.scrollTo({
      top: scrollTarget,
      behavior: 'smooth'
    });
  }

  convertToPixels(value) {
    if (value.endsWith('px')) {
      return parseFloat(value);
    }

    // Fallback for rem/em or other units
    const temp = document.createElement('div');
    temp.style.position = 'absolute';
    temp.style.visibility = 'hidden';
    temp.style.height = value;
    document.body.appendChild(temp);
    const pixels = parseFloat(getComputedStyle(temp).height);
    document.body.removeChild(temp);
    return pixels;
  }




  slideDown(element) {
    element.style.height = '0px';
    element.style.display = 'block';
    const height = element.scrollHeight;
    element.style.transition = `height ${this.animationSpeed}ms ease`;
    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });
    setTimeout(() => {
      element.style.height = '';
      element.style.transition = '';
    }, this.animationSpeed);
  }

  slideUp(element) {
    const height = element.scrollHeight;
    element.style.height = `${height}px`;
    element.style.transition = `height ${this.animationSpeed}ms ease`;
    requestAnimationFrame(() => {
      element.style.height = '0px';
    });
    setTimeout(() => {
      element.style.display = 'none';
      element.style.height = '';
      element.style.transition = '';
    }, this.animationSpeed);
  }
}

export { ExpandingContent };

